import React from 'react';
import { Link } from 'react-router-dom';
import { FaCode, FaServer, FaLayerGroup, FaInfinity, FaCubes, FaCloud } from 'react-icons/fa';
import servicesData from './servicesData';
import styles from './Services.module.css';

const serviceIcons: Record<string, React.ReactElement> = {
  frontend: <FaCode size={20} />,
  backend: <FaServer size={20} />,
  fullstack: <FaLayerGroup size={20} />,
  devops: <FaInfinity size={20} />,
  infrastructure: <FaCubes size={20} />,
  cloud: <FaCloud size={20} />,
};

const Services: React.FC = () => {
  return (
    <div className={styles.services}>
      <h2>Services</h2>
      <p className={styles.subtitle}>
        Available for consulting engagements — short-term or ongoing. Please contact me via email or LinkedIn if you want to have a talk about anything.
        {' '}View the <Link to="/commercial-disclosure" className={styles.disclosureLink}>Commercial Disclosure</Link> page for business and payment information.
      </p>
      <div className={styles.servicesGrid}>
        {servicesData.map((service) => (
          <div key={service.id} className={styles.serviceCard}>
            <div className={styles.cardHeader}>
              <span className={styles.cardIcon} aria-hidden="true">
                {serviceIcons[service.id]}
              </span>
              <h3>{service.title}</h3>
            </div>
            <p className={styles.cardDescription}>{service.description}</p>
            <div className={styles.tagList}>
              {service.tags.map((tag) => (
                <span key={tag} className={styles.tag}>
                  {tag}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
